import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { useUser } from '../context/UserContext';
import { useRestaurante } from '../context/RestauranteContext';

const SelectBoxFornecedor = ({ value, onChange }) => {
  const { restauranteId } = useRestaurante();
  const [fornecedores, setFornecedores] = useState([]);

  useEffect(() => {
    const fetchFornecedores = async () => {
      const user = sessionStorage.getItem("user");
      const { access_token } = JSON.parse(user);
      if (restauranteId && access_token) {
        try {
          const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/fornecedores/list-select?restauranteId=${restauranteId}`, {
            headers: {
              "Content-Type": "application/json",
              "Authentication": access_token
            },
          });
          const data = await response.json();
          setFornecedores(data);
        } catch (error) {
          console.error('Erro ao buscar fornecedores:', error);
        }
      }
    };

    fetchFornecedores();
  }, [restauranteId]);

  const options = fornecedores.map(fornecedor => ({
    value: fornecedor.id,
    label: fornecedor.nome
  }));

  const selectedOption = options.find(option => option.value === value) || null;

  const handleChange = selected => {
    onChange(selected ? selected.value : '');
  };

  return (
    <div style={{ width: 300 }}>
      <div className="periodo-selecionado">
        <label htmlFor="select-box-fornecedor" style={{ display: 'block', marginBottom: 8 }}>
            Selecione um fornecedor:
        </label>
      </div>
      <Select
        inputId="select-box-fornecedor"
        value={selectedOption}
        onChange={handleChange}
        options={options}
        placeholder="Selecione..."
        isClearable
        styles={{
          control: (base) => ({
            ...base,
            borderColor: '#ccc',
            boxShadow: 'none',
            '&:hover': { borderColor: '#007bff' }
          })
        }}
      />
    </div>
  );
};

export default SelectBoxFornecedor;
